

/* ------------------------------------------------------------------
 * HOOK: useSubjectIdcardService
 * ------------------------------------------------------------------ */

import { useMutation } from "@tanstack/react-query";
import { IdcardApiService } from "./idcard.api";

export const useSubjectIdcardService = () => {
    const InsertReprintHistoryMutation = useMutation({
        mutationFn: (payload: any) => IdcardApiService.insertHistory(payload),
    });

    return {
        InsertReprintHistoryMutation,
    };
};